
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit, Input, OnChanges, SimpleChange, OnDestroy } from '@angular/core';
import { Category } from '../../../../../models/category';
import { Constants } from '../../../../../common/constants';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { Subject} from 'rxjs';
import { PageRequest, Sort } from '@pdp/common';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
    selector: 'pdp-product-list-header',
    templateUrl: './product-list-header.component.html',
    styleUrls: ['./product-list-header.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, MatSelect, NgFor, MatOption, NgClass]
})
export class ProductListHeaderComponent implements OnInit, OnChanges, OnDestroy {

  constructor(
              public activatedRoute: ActivatedRoute,
              public router: Router) {
    this.buildForm();
  }

  public resultSpan: any;

  @Input()
  public category: Category;

  private unsubscribe: Subject<void> = new Subject();

  public sortForm: UntypedFormGroup;

  // default to Cena rastuća
  public sortValue = '2';
  public options  = [/*{"key":"1","value":"Najpopularnije"},*/
                      {'key': '2', 'value': $localize`:@@SortirajPoCeni:Cena rastuća`},
                      {'key': '3', 'value': $localize`:@@SortirajPoCeni:Cena opadajuća`},
                    ];

  /**
   * On each change of category Input() calculate new result span
   */
  ngOnChanges(changes: {[propName: string]: SimpleChange}) {
      this.resultSpan = 0;
      if (this.category.page && this.category.page.numberOfElements > 0) {
        let start = this.category.page.number * this.category.page.size;
        const end = start + this.category.page.numberOfElements;
        start++;
        this.resultSpan = start + ' - ' + end;
      }
  }


  ngOnInit() {
    this.activatedRoute.queryParams
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(queryParams => {
      const changeType = queryParams['changeType'];
      const sortOrder = queryParams['sortOrder'];

      if (changeType && changeType === 'sortBy') {
        // patchuj sortBy select drop down samo ukoliko je klijent zeleo drugaciji sort, a ne ukoliko je promenio stranicu
        // FIX THIS trenutno sortiramo samo po ceni tako da zanemarujem sortBy parametar nego samo uzimam desc ili asc.
        // Kada budemo sortirali po recimo najpopularnije doraditi ovu pitalicu
        if (sortOrder === 'DESC') {
          this.sortValue = '3';
        } else {
          this.sortValue = '2';
        }
        const sortOrderControl = this.sortForm.get('selectValue');
        sortOrderControl.patchValue(this.sortValue);
      }
    });
  }

  public subcribeToFormChanges() {

        // after each value change on sorting select dropdown, send data to this.onValueChanged
      this.sortForm.controls['selectValue'].valueChanges/*.pipe(skip(1))*/
      .pipe(takeUntil(this.unsubscribe)).subscribe(sortBy => {
          // this.defautlSortValue=sortBy;
          this.changePage(this.constructPageRequest(sortBy), this.category.searchParam, 0, 'sortBy');
      });
  }

  /**
   * Builds sorting select dropdown form
   */
  public buildForm(): void {
            this.sortForm = new UntypedFormGroup({
                selectValue : new UntypedFormControl(null, [])
            });

      const sortOrderControl = this.sortForm.get('selectValue');
      sortOrderControl.patchValue(this.sortValue);
      this.subcribeToFormChanges();
  }


  // *ngFor only iterates over collections so we are creating collection out of totalPages
  public createRange(number) {
      const items: number[] = [];
      for (let i = 1; i <= number; i++) {
        items.push(i);
      }
    return items;
  }

  /**
   * Change loaded content. Whether it is a page change with same content or request new content sorted by different rule
   */
  public changePage(pageRequest: PageRequest, searchParam: string, page?: number, changeType?: string) {
    const navigationExtras: NavigationExtras = {
        queryParams: {
            'q': searchParam,
            'page': page,
            'size': pageRequest['pageSize'],
            'sortBy': pageRequest['sort'][0]['property'],
            'sortOrder': pageRequest['sort'][0]['direction'],
            'changeType': changeType
        },
         relativeTo: this.activatedRoute
    };
      this.router.navigate([], navigationExtras);
  }

  // Create same response like spring pageable with sort array included
  // Constructs sort. Used for select dropdown
  public constructPageRequest(sortBy: String): PageRequest {
        if (!sortBy) {
          return;
        }
        let pageRequest: PageRequest;
         switch (sortBy) {
          case '1':
            pageRequest = new PageRequest(0, Constants.sortBy.PRICE, Constants.SortOrder.ASC, this.constructSortForPageRequest(Constants.SortOrder.ASC, Constants.sortBy.PRICE, false, 'Native', true));
            break;
          case '2':
            pageRequest = new PageRequest(0, Constants.sortBy.PRICE, Constants.SortOrder.ASC, this.constructSortForPageRequest(Constants.SortOrder.ASC, Constants.sortBy.PRICE, false, 'Native', true));
            break;
          case '3':
            pageRequest = new PageRequest(0, Constants.sortBy.PRICE, Constants.SortOrder.DESC, this.constructSortForPageRequest(Constants.SortOrder.DESC, Constants.sortBy.PRICE, false, 'Native', false));

            // introduce bestseller rank
            // pageRequest =new PageRequest(0,Constants.sortBy.BEST_SELLER_RANK,Constants.SortOrder.DESC);
            break;
          default:
            // default price ascending
            pageRequest = new PageRequest(0, Constants.sortBy.PRICE, Constants.SortOrder.ASC, this.constructSortForPageRequest(Constants.SortOrder.ASC, Constants.sortBy.PRICE, false, 'Native', true));
        }
        return pageRequest;
   }


   public constructSortForPageRequest(direction: string, property: string, ignoreCase: boolean, nullHandling: string, ascending: boolean): Sort[] {

     const sortArray: Sort[] = [];
     sortArray[0] = new Sort(direction, property, ignoreCase, nullHandling, ascending);
     return sortArray;
   }

   ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
